// extracted by mini-css-extract-plugin
module.exports = {"inputbox":"Menu_inputbox__3Bb6X"};